const timelineData = [
  {
    year: "2023",
    title: "Preseason Kickoff",
    date: "September 20, 2023",
    description: "Our first meeting of the season!"
  },
  {
    year: "2023",
    title: "Outreach, Plymouth Parade",
    date: "September 23, 2023",
    description: "We spread the word about STEM education in our community!"
  },
  {
    year: "2023",
    title: "Outreach, Homecoming Football Game",
    date: "October 6, 2023",
    description: "We showed Wayzata Trojan spirit using our Wayzata T-shirt cannon!"
  },
  {
    year: "2023",
    title: "Medtronic Jumpstart Event",
    date: "October 28, 2023",
    description: "We learned about robotics applications and met other teams."
  },
  {
    year: "2024",
    title: "Season Kickoff",
    date: "January 5, 2024",
    description: "Reveal of the Crescendo challenge and brainstorming!"
  },
  {
    year: "2024",
    title: "Duluth Competition",
    date: "Feb 28 – March 2, 2024",
    description: "Our first regional tournament of the season!"
  },
  {
    year: "2025",
    title: "Homecoming Football Game ",
    date: "October 3, 2025",
    description: "We displayed Trojan pride with our t-shirt shooting robot. The crowds went wild!"
  },
  {
    year: "2025",
    title: "Tackle Cancer Football Game",
    date: "October 10, 2025",
    description: "We contributed to raising awareness towards cancer."
  },
  {
    year: "2025",
    title: "Medtronic Jumpstart",
    date: "October 25, 2025",
    description: "We presented at Jumpstart and met so many new teams!"
  },
   {
    year: "2025",
    title: "STEMtacular Event",
    date: "November 8, 2025",
    description: "We showcased our competition and t-shirt shooting robot to the next generation of STEM enthusiasts"
  },
  {
    year: "2026",
    title: "Season Kickoff",
    date: "January 10, 2026",
    description: "We showcased our competition and t-shirt shooting robot to the next generation of STEM enthusiasts"
  },
  {
    year: "2026",
    title: "North Star Regional",
    date: "April 1-4 2026",
    description: "Our robotics team competed at the North Star Regional hosted at the University of Minnesota, where we ranked 10th and had a great experience competing and watching other teams’ robots in action."
  },
  
]
export default timelineData;





